module.exports = {"DATE_SELECT_DAY":"วัน","DATE_SELECT_MONTH":"เดือน","DATE_SELECT_YEAR":"ปี"}